"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preloader_store_1 = require("@App/stores/ui/preloader-store");
const ui_store_1 = require("@App/stores/ui/ui-store");
const popup_state_1 = require("@App/stores/ui/popup-state");
const auth_state_1 = require("@App/stores/auth/auth-state");
const lib_store_1 = require("@App/stores/lib/lib-store");
const current_rightsholder_store_1 = __importDefault(require("@App/stores/rightsholder/current-rightsholder-store"));
const rightsholder_user_store_1 = require("@App/stores/rightsholder/rightsholder-user-store");
const statements_store_1 = require("@App/stores/rightsholder/statements-store");
const contact_store_1 = require("@App/stores/rightsholder/contact-store");
const matching_store_1 = require("@App/stores/rightsholder/matching-store");
const user_store_1 = require("@App/stores/user/user-store");
const catalog_search_store_1 = require("@App/stores/search/catalog-search-store");
const work_store_1 = require("@App/stores/work/work-store");
const publisher_search_store_1 = require("@App/stores/search/publisher-search-store");
const writer_search_store_1 = require("@App/stores/search/writer-search-store");
const work_search_store_1 = require("@App/stores/search/work-search-store");
const bulk_upload_store_1 = require("@App/stores/work/bulk-upload-store");
const claiming_tool_search_store_1 = require("@App/stores/search/claiming-tool-search-store");
const create_work_search_store_1 = __importDefault(require("@App/stores/search/create-work-search-store"));
const public_search_works_store_1 = __importDefault(require("@App/stores/search/public/public-search-works-store"));
const public_search_writers_store_1 = __importDefault(require("@App/stores/search/public/public-search-writers-store"));
const public_search_publishers_store_1 = __importDefault(require("@App/stores/search/public/public-search-publishers-store"));
const public_view_work_store_1 = require("@App/stores/search/public/public-view-work-store");
const create_password_store_1 = __importDefault(require("@App/stores/user/create-password-store"));
const publisher_step_store_1 = __importDefault(require("@App/stores/work/steps/publisher-step-store"));
const match_history_store_1 = require("@App/stores/rightsholder/match-history-store");
const export_store_1 = require("@App/stores/export/export-store");
const create_rightsholder_store_1 = __importDefault(require("@App/stores/rightsholder/create-rightsholder-store"));
const rightsholder_search_store_1 = __importDefault(require("@App/stores/search/rightsholder-search-store"));
const WizardFlowStore_1 = __importDefault(require("@App/stores/wizardFlow/WizardFlowStore"));
const overclaim_search_store_1 = require("@App/stores/overclaim/overclaim-search-store");
const overclaim_view_store_1 = require("@App/stores/overclaim/overclaim-view-store");
const claim_tool_store_1 = require("@App/stores/work/claim-tool-store");
const registration_history_store_1 = __importDefault(require("@App/stores/rightsholder/registrationHistory/registration-history-store"));
const songwriter_search_store_1 = __importDefault(require("@App/stores/search/songwriter-search-store"));
const current_songwriter_store_1 = __importDefault(require("@App/stores/songwriter/current-songwriter-store"));
const songwriter_writer_search_store_1 = __importDefault(require("@App/stores/search/songwriter-writer-search-store"));
const songwriter_catalog_search_store_1 = __importDefault(require("@App/stores/search/songwriter-catalog-search-store"));
const songwriter_mywriter_search_store_1 = __importDefault(require("@App/stores/search/songwriter-mywriter-search-store"));
const notification_store_1 = __importDefault(require("@App/stores/user/notification-store"));
class RootStore {
    constructor(router) {
        Object.defineProperty(this, "preloaderStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "popupStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "uiStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "libStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rightsholderStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rightsholderUserStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "statementsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "catalogSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publisherSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "writerSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "matchingStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "matchHistoryStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exportStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "overclaimSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "overclaimViewStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bulkUploadStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicSearchWorksStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicSearchWritersStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicSearchPublishersStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicViewWorkStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createPasswordStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publisherStepStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createRightsholderStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rightsholderSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "songwriterSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "songwriterStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "songwriterWriterSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "songwriterMyWriterSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "songwriterCatalogSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "router", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "wizardFlowStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "claimingToolSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "claimToolStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createWorkSearchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registrationHistoryStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notificationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.rightsholderStore = new current_rightsholder_store_1.default(this);
                this.rightsholderUserStore = new rightsholder_user_store_1.RightsholderUserStore(this);
                this.userStore = new user_store_1.UserStore(this);
                this.statementsStore = new statements_store_1.StatementsStore(this);
                this.catalogSearchStore = new catalog_search_store_1.CatalogSearchStore(this);
                this.publisherSearchStore = new publisher_search_store_1.PublisherSearchStore(this);
                this.writerSearchStore = new writer_search_store_1.WriterSearchStore(this);
                this.workSearchStore = new work_search_store_1.WorkSearchStore(this);
                this.contactStore = new contact_store_1.ContactStore(this);
                this.matchingStore = new matching_store_1.MatchingStore(this);
                this.matchHistoryStore = new match_history_store_1.MatchHistoryStore(this);
                this.workStore = new work_store_1.WorkStore(this);
                this.exportStore = new export_store_1.ExportStore(this);
                this.bulkUploadStore = new bulk_upload_store_1.BulkUploadStore(this);
                this.publicSearchWorksStore = new public_search_works_store_1.default(this);
                this.publicSearchWritersStore = new public_search_writers_store_1.default(this);
                this.publicSearchPublishersStore = new public_search_publishers_store_1.default(this);
                this.publicViewWorkStore = new public_view_work_store_1.PublicViewWorkStore(this);
                this.createPasswordStore = new create_password_store_1.default(this);
                this.publisherStepStore = new publisher_step_store_1.default(this);
                this.overclaimSearchStore = new overclaim_search_store_1.OverclaimSearchStore(this);
                this.overclaimViewStore = new overclaim_view_store_1.OverclaimViewStore(this);
                this.createRightsholderStore = new create_rightsholder_store_1.default(this);
                this.rightsholderSearchStore = new rightsholder_search_store_1.default(this);
                this.songwriterSearchStore = new songwriter_search_store_1.default(this);
                this.songwriterStore = new current_songwriter_store_1.default(this);
                this.songwriterWriterSearchStore = new songwriter_writer_search_store_1.default(this);
                this.songwriterMyWriterSearchStore = new songwriter_mywriter_search_store_1.default(this);
                this.songwriterCatalogSearchStore = new songwriter_catalog_search_store_1.default(this);
                this.wizardFlowStore = new WizardFlowStore_1.default();
                this.claimingToolSearchStore = new claiming_tool_search_store_1.ClaimingToolSearchStore(this);
                this.claimToolStore = new claim_tool_store_1.ClaimToolStore(this);
                this.createWorkSearchStore = new create_work_search_store_1.default(this);
                this.registrationHistoryStore = new registration_history_store_1.default(this);
                this.uiStore = new ui_store_1.UiStore(this);
                this.notificationStore = new notification_store_1.default(this);
            }
        });
        this.resetStore();
        // These stores do not need to be reset - they're bound to the base
        // components of the app that are *not* remounted if the user logs out
        this.libStore = new lib_store_1.LibStore();
        this.preloaderStore = new preloader_store_1.PreloaderStore();
        this.popupStore = new popup_state_1.PopupStore();
        this.router = router;
        this.authStore = new auth_state_1.AuthStore(this);
    }
}
exports.default = RootStore;
